import { useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { landingPage } from 'common'
import { useStore } from 'store'
import { maskEmail } from 'utils'
import useIsPublicPage from 'hooks/useIsPublicPage'
import { EmailIcon } from 'icons'
import copy from 'copy.json'
import { basePaths } from 'paths'

import Button from 'components/Button'

export default function SuccessScreen() {
  const isPublicPage = useIsPublicPage()
  const { currentUser } = useStore()
  const location = useLocation()
  const navigate = useNavigate()
  const email: string = currentUser?.email || location.state?.email || ''

  const redirect = useCallback(() => {
    isPublicPage ? (window.location.href = landingPage) : navigate(basePaths.admin_panel)
  }, [isPublicPage, navigate])

  useEffect(() => {
    if (!email) redirect()
  }, [email, redirect])

  if (!email) return null

  return (
    <Wrapper className="dark">
      <EmailIcon />

      <h1>{copy.page.success.heading}</h1>

      <p>
        {copy.page.success.paragraph_1}
        {maskEmail(email)}.
        <br />
        {copy.page.success.paragraph_2}
      </p>

      <Button onClick={redirect} secondary>
        {copy.common.button.close}
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  width: 100%;
  max-width: 646px;
  margin: 50px auto 0;
  padding: 48px clamp(48px, 20vw, 110px);
  color: var(--white);

  background: var(--green);
  border-radius: 4px;

  h1 {
    font: var(--600-24);
  }

  p {
    font: var(--400-15);
    text-align: center;
  }

  button {
    width: 100%;
    max-width: 312px;

    &:hover:enabled:not(:focus-visible) {
      background: var(--very-light-green);
    }
  }
`
